import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

import { Box, BoxProps, Heading, Text } from "@vinomofo/components";

import { Link } from "../../link";
import { ThreeUpBannerProps } from "./ThreeUpBannerGroup";
import { justificationForTextPosition } from "./helpers";

type SecondaryBannerProps = BoxProps & ThreeUpBannerProps;

const BannerLink = styled(Link)`
  width: 100%;
  text-decoration: none;
`;

export const SecondaryBanner = ({
  title,
  image,
  subtitle,
  primaryCta,
  textPosition = "left",
  titleColor = "white",
  subtitleColor = "white",
  ...rest
}: SecondaryBannerProps): JSX.Element => {
  const linkTo = primaryCta?.linkTo?.path || primaryCta?.linkTo?.url;
  const target = primaryCta?.linkTo?.target && primaryCta?.linkTo?.target === "New Tab" ? "_new" : "_self";
  return (
    <a href={linkTo} target={target} rel="noopener" style={{textDecoration: "none"}}>
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        height="100%"
        position="relative"
        overflow="hidden"
        padding={["20px", "30px", "40px"]}
        justifyContent={justificationForTextPosition[textPosition]}
        {...rest}
      >
        <GatsbyImage
          alt=""
          image={image}
          objectFit="cover"
          objectPosition="center center"
          style={{
            position: "absolute",
            zIndex: -1,
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
          }}
        />
        <Box width="50%">
          <Box mb="1em">
            <Heading variant="sm" color={titleColor}>
              {title}
            </Heading>
          </Box>
          <Text color={subtitleColor} lineHeight="tight" variant="sm">
            {subtitle}
          </Text>
        </Box>
      </Box>
    </a>
  );
};
